// Locale configuration for WunderMemos web frontend
// Matches the 21 languages supported by the iPhone app

export interface LocaleConfig {
  code: string
  name: string           // Native name (e.g., "Deutsch")
  englishName: string    // English name (e.g., "German")
  dir: 'ltr' | 'rtl'
  flag: string           // Emoji flag
}

export const SUPPORTED_LOCALES: LocaleConfig[] = [
  { code: 'en', name: 'English', englishName: 'English', dir: 'ltr', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', englishName: 'German', dir: 'ltr', flag: '🇩🇪' },
  { code: 'es', name: 'Español', englishName: 'Spanish', dir: 'ltr', flag: '🇪🇸' },
  { code: 'es-419', name: 'Español (Latinoamérica)', englishName: 'Spanish (Latin America)', dir: 'ltr', flag: '🌎' },
  { code: 'fr', name: 'Français', englishName: 'French', dir: 'ltr', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', englishName: 'Italian', dir: 'ltr', flag: '🇮🇹' },
  { code: 'pt', name: 'Português', englishName: 'Portuguese', dir: 'ltr', flag: '🇵🇹' },
  { code: 'pt-BR', name: 'Português (Brasil)', englishName: 'Portuguese (Brazil)', dir: 'ltr', flag: '🇧🇷' },
  { code: 'ja', name: '日本語', englishName: 'Japanese', dir: 'ltr', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', englishName: 'Korean', dir: 'ltr', flag: '🇰🇷' },
  { code: 'zh', name: '简体中文', englishName: 'Chinese (Simplified)', dir: 'ltr', flag: '🇨🇳' },
  { code: 'zh-TW', name: '繁體中文', englishName: 'Chinese (Traditional)', dir: 'ltr', flag: '🇹🇼' },
  { code: 'ar', name: 'العربية', englishName: 'Arabic', dir: 'rtl', flag: '🇸🇦' },
  { code: 'hi', name: 'हिन्दी', englishName: 'Hindi', dir: 'ltr', flag: '🇮🇳' },
  { code: 'id', name: 'Bahasa Indonesia', englishName: 'Indonesian', dir: 'ltr', flag: '🇮🇩' },
  { code: 'tr', name: 'Türkçe', englishName: 'Turkish', dir: 'ltr', flag: '🇹🇷' },
  { code: 'ru', name: 'Русский', englishName: 'Russian', dir: 'ltr', flag: '🇷🇺' },
  { code: 'nl', name: 'Nederlands', englishName: 'Dutch', dir: 'ltr', flag: '🇳🇱' },
  { code: 'pl', name: 'Polski', englishName: 'Polish', dir: 'ltr', flag: '🇵🇱' },
  { code: 'sv', name: 'Svenska', englishName: 'Swedish', dir: 'ltr', flag: '🇸🇪' },
  { code: 'th', name: 'ภาษาไทย', englishName: 'Thai', dir: 'ltr', flag: '🇹🇭' },
]

export const DEFAULT_LOCALE = 'en'
export const RTL_LOCALES = SUPPORTED_LOCALES.filter(l => l.dir === 'rtl').map(l => l.code)

export function getLocaleConfig(code: string): LocaleConfig | undefined {
  return SUPPORTED_LOCALES.find(l => l.code === code)
}

export function isRTL(code: string): boolean {
  return RTL_LOCALES.includes(code)
}

// Get supported locale codes for validation
export function getSupportedLocaleCodes(): string[] {
  return SUPPORTED_LOCALES.map(l => l.code)
}
